import FirebaseService from '../service/firebase/FirebaseService';

const collectionName = 'user';

const FetchUserTags = async (userId) => {
    const docName = userId;
    const snap = await FirebaseService.getDocument(collectionName, docName);
    return snap['tags'];
}

const tags = [
   // 인사이트, 여행, 친구, 업무, 학업, 회고, 연애, 추억, 기타
    {id:1, tagName: "인사이트", color: "#2F53A1" },
    {id:2, tagName: "여행", color: "#809A7D" },
    {id:3, tagName: "친구", color: "#D7B669" },
    {id:4, tagName: "업무", color: "#B1BE63" },
    {id:5, tagName: "학업", color: "#AA9F88" },
    {id:6, tagName: "회고", color: "#3C3C3C" },
    {id:7, tagName: "연애", color: "#EC5C28" },
    {id:8, tagName: "추억", color: "#9BBBB8" },
    {id:9, tagName: "기타", color: "#2F53A1" },
  ];
  
  const hashs = [
    {id:1, tagName: "디스콰이엇", color: "#9E86D0" },
  ];

export { tags, hashs, FetchUserTags}